import { render } from "./Draft.vue?vue&type=template&id=0732d7d0&scoped=true"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"

import "./Draft.vue?vue&type=style&index=0&id=0732d7d0&scoped=true&lang=scss"
import "./Draft.vue?vue&type=style&index=1&id=0732d7d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0732d7d0"]])

export default __exports__